<template>
  <v-card elevation="0">
    <div class="pa-">
      <h5>Vendas por Setor</h5>
      <v-alert
        v-if="reducedPayments.length === 0"
        class="mb-0"
        color="warning"
        variant="tonal"
        text
      >
        Nenhum dado encontrado, verifique as filtros
      </v-alert>
      <div class="d-flex flex-column gap-3">
        <v-card
          v-for="ticketGroup in reducedPayments"
          :key="`ticketGroup-${ticketGroup.id}`"
          class="rounded"
          outlined
          :loading="loading"
        >
          <div class="pa-3 pb-0">
            <b>{{ ticketGroup.name }}</b>
          </div>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Lote</th>
                <th class="text-end">Preço</th>
                <th class="text-center">Ingressos Vendidos</th>
                <th class="text-center">Cortesias</th>
                <th class="text-center">Ingressos Emitidos</th>
                <th class="text-end">Valor Líquido</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="ticketBlock in ticketGroup.ticketBlocks"
                :key="`item-${ticketBlock.id}`"
              >
                <td colspan="1">{{ ticketBlock.name }}</td>
                <td colspan="1" class="text-end">
                  {{ ticketBlock.price | currency }}
                </td>
                <td colspan="1" class="text-center">
                  {{ (ticketBlock.quantity - ticketBlock.courtesy) | number }}
                </td>
                <td colspan="1" class="text-center">
                  {{ ticketBlock.courtesy | number }}
                </td>
                <td colspan="1" class="text-center">
                  {{ ticketBlock.quantity | number }}
                </td>
                <td colspan="1" class="text-end">
                  {{ ticketBlock.amount | currency }}
                </td>
              </tr>
              <tr class="font-weight-bold text-15">
                <td colspan="2">Total</td>
                <td colspan="1" class="text-center">
                  {{ (ticketGroup.quantity - ticketGroup.courtesy) | number }}
                </td>
                <td colspan="1" class="text-center">
                  {{ ticketGroup.courtesy | number }}
                </td>
                <td colspan="1" class="text-center">
                  {{ ticketGroup.quantity | number }}
                </td>
                <td colspan="1" class="text-end">
                  {{ ticketGroup.amount | currency }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ResumeSalesByTicketGroup",
  props: {
    party: {
      type: Object,
      required: true,
    },
    payments: {
      type: Array,
      required: true,
    },
    tickets: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    reducedPayments() {
      const reducedPayments = this.tickets.reduce((acc, ticket) => {
        const { TicketGroup, ...ticketBlock } = ticket.TicketBlock;
        const ticketGroup = TicketGroup;
        const payment = ticket.Payment;

        if (!acc[ticketGroup.id]) {
          acc[ticketGroup.id] = {
            ...ticketGroup,
            quantity: 0,
            courtesy: 0,
            amount: 0,
            ticketBlocks: {},
          };
        }

        if (!acc[ticketGroup.id].ticketBlocks[ticketBlock.id]) {
          acc[ticketGroup.id].ticketBlocks[ticketBlock.id] = {
            ...ticketBlock,
            price: ticketBlock.price,
            tamount: ticketBlock.amount,
            quantity: 0,
            courtesy: 0,
            amount: 0,
          };
        }

        // sum ticket group
        acc[ticketGroup.id].quantity += 1;
        acc[ticketGroup.id].amount += ticket.amount - ticket.platformFee;

        // sum ticket block
        acc[ticketGroup.id].ticketBlocks[ticketBlock.id].amount +=
          ticket.amount - ticket.platformFee;
        acc[ticketGroup.id].ticketBlocks[ticketBlock.id].quantity += 1;

        const isCourtesy = payment.paymentType === "COURTESY";
        if (isCourtesy) {
          acc[ticketGroup.id].courtesy++;
          acc[ticketGroup.id].ticketBlocks[ticketBlock.id].courtesy++;
        }

        return acc;
      }, {});
      return Object.values(reducedPayments).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
  },
};
</script>
